const config = {
  // baseUrl: 'http://localhost:8800',
  // baseUrl: "https://dptadminapi.msg-demo.com",
  baseUrl: "https://dptadminapi.msgwddemo.in"
};

export default config;
